import { useQuery } from "@tanstack/react-query";

import { ITCodeRequestService } from "../../../../../services/it-code-request/itCodeRequest.service";
import { requestStatus } from "../../../../../constants";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../delete-user-account/utils";
import { transformRequestStatus } from "../../../utils";
import { useUser } from "../../../../../hook";

export const useCodeProcessRequests = () => {
  const {email} = useUser();
  const emailThienNV = 'thiennv@viags.vn';
  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["code-process-requests"],
    queryFn: () =>
      ITCodeRequestService.getITCodeRequests(emailThienNV, requestStatus.submitted),
  });

  const { data: data2 = [], ...restResponse2 } = useQuery<Array<any>>({
    queryKey: ["code-process-requests2"],
    queryFn: () =>
      ITCodeRequestService.getITCodeRequests(email, requestStatus.submitted),
  });

  const codeProcessMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === email.toLowerCase()
  );

  const mappedCodeProcessRequests = data.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, emailThienNV);
    const step = getStepBaseOnApprover(record.fields, emailThienNV);
    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);

  const mappedCodeProcessRequests2 = data2.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, emailThienNV);
    const step = getStepBaseOnApprover(record.fields, emailThienNV);
    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);

  const mappedCodeProcessMyRequests = mappedCodeProcessRequests.filter(
    (record) => record.createdByEmail.toLowerCase() === email.toLowerCase()
  ).sort((a,b) => b.id - a.id);

  const guideLink = "https://drive.google.com/file/d/1txGr0CH_t1ReS31DMuInxtlc_RPXPGFE/view"

  return {
    ...restResponse,
    ...restResponse2,
    codeProcessRequests: data,
    codeProcessRequests2: data2,
    codeProcessMyRequests,
    mappedCodeProcessRequests,
    mappedCodeProcessRequests2,
    mappedCodeProcessMyRequests,
    guideLink
  };
};
